import * as React from 'react';
import { IconButton, TableContainer, Table, TableHead, TableRow, TableBody, TableCell, Icon } from '@material-ui/core';
import EditCurrentEmployee from './EditCurrentEmployee';
import { IEmployeesFilterParams, OptionType } from '../EmployeesComboboxMI';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import DeleteWarningDialog from './DeleteWarningDialog';
import { IResourceInputConfig } from './Models';

interface ITableHeaderColumnProps {
	className?: string;
	action?: string;
	minWidth?: number;
	render?: (row: any) => any
}

export interface IEmployeeEntity {
	name: string,
	label: string,
	id: number,
	kind: string,
	type: string,
}

export interface IRelationRowTable {
	deleted: boolean,
	key: number,
	relationId?: number,
	employee: IEmployeeEntity,

	errorMessages: IErrorMessageJsonData[],
}

export interface IRequestTable {
	employee: IEmployeeEntity,
	request: IRelationRowTable[]
}

export interface IErrorMessageJsonData {
	column: string | null,
	errorMessage: string
}

export type IAllRequest = { [id: string]: IRequestTable }

export class TableHeaderColumn extends React.Component<ITableHeaderColumnProps> {
	render() {
		return <TableCell className={this.props.className} style={{ minWidth: this.props.minWidth }}>
			{this.props.children}
		</TableCell>;
	}
}

interface IEmployeeInfoProps {
	currentEmployee: OptionType,
	editCurrentEmployee: boolean,
	filters: IEmployeesFilterParams,
	employeeRelationsWindow: (row: OptionType) => any;
	onChange: (employee: OptionType) => void;
	employeesConfig: IResourceInputConfig,
}

function EmployeeInfoHeader(props: { currentEmployee: OptionType }) {
	const { t } = useTranslation();

	return <span className="access-for-user">
		{t("control.relation.requestFor")}:{' '}
		{props.currentEmployee && <strong>{props.currentEmployee.label}</strong>}
		{!props.currentEmployee && <span className="text-gray">&lt;{t("common.none")}&gt;</span>}
	</span>
}

function EmployeeInfo(props: IEmployeeInfoProps) {
	const { t } = useTranslation();
	return <div className="employee-for-info">
		<EmployeeInfoHeader currentEmployee={props.currentEmployee} />
		{props.employeeRelationsWindow(props.currentEmployee)}
		{props.editCurrentEmployee && <EditCurrentEmployee
			value={props.currentEmployee}
			onChange={props.onChange}
			filters={props.filters}
			personLabel={t("control.relation.selectEmployee")}
			employeesConfig={props.employeesConfig}
		/>}
	</div>
}

interface ITableByResourceKindProps {
	children: any,
	table: IRelationRowTable[]
	kind: string,
	label: string,

	edit: boolean,
	copy: boolean,
	remove: boolean,
	onEditClick,
	onCopyClick,
	onDeleteClick,

	classNameRow?: (row: IRelationRowTable) => string;
}

function TableByResourceKind(props: ITableByResourceKindProps)
{
	const { t } = useTranslation();
	return <div className={"relation-table-container relation-table-container-" + props.kind}>
		<div className="relation-table-container-label">
			{props.label}
		</div>
		<TableContainer component={Paper}>
			<Table className="table table-hover">
				<TableHead>
					<TableRow>
						<TableCell padding="none" className="paddingNone" />
						<TableCell padding="none" className="paddingNone" />
						<TableCell padding="none" className="paddingNone"  />
						{props.children}
					</TableRow>
				</TableHead>
				<TableBody>{props.table.map((row) => {

					if (row.deleted)
						return null;

					let classNames = "";
					if (props.classNameRow)
						classNames = props.classNameRow(row);

					var rowIsSaved = !!(row as any).id;
					return <TableRow key={row.key} className={"relation-row " + classNames}>
						<TableCell padding="none" className="paddingNone" >{props.edit &&
							<IconButton type="button" className="mi-button-icon" color="default" data-key={row.key} onClick={(e) => props.onEditClick(e, row)}>
							<span className="material-icons" title={t("common.action.edit")} >edit</span>
							</IconButton>}
						</TableCell>
						<TableCell padding="none" className="paddingNone" >{props.copy  &&
							<IconButton type="button" className="mi-button-icon" color="default" data-key={row.key} onClick={(e) => props.onCopyClick(e, row)}>
								<span className="material-icons" title={t("common.action.copy")} >file_copy</span>
							</IconButton>}
						</TableCell>
						<TableCell padding="none" className="paddingNone" >
							{(props.remove || !rowIsSaved) && <IconButton type="button" className="mi-button-icon" color="secondary" onClick={() => props.onDeleteClick(row)} >
								<span className="material-icons" title={t("common.action.delete")} >clear</span>
							</IconButton>}
						</TableCell>
						{(props.children as any[]).map((col, i) => {
							if (!col?.props)
								return null;

							var td = null;
							if (col.props.render)
								td = col.props.render(row);

							return <TableCell key={i} className={col.props.className}>{td}</TableCell>
						})}
					</TableRow>
				})}
				</TableBody>
			</Table>
		</TableContainer>
	</div>
}

interface IRequestnByUserProps {
	children: any,
	editCurrentEmployee: boolean,

	edit: boolean,
	copy: boolean,
	remove: boolean,

	employeeRelationsWindow: (row: OptionType) => any;
	classNameRow?: (row: IRelationRowTable) => string;
	getTableLabel?: (kind: string) => string;
	employeesFilters: IEmployeesFilterParams,

	onEditClick,
	onCopyClick,
	onDeleteClick,
	onChangeEmployee,

	employeesConfig?: IResourceInputConfig,
}

function RequestByUser(props: IRequestTable & IRequestnByUserProps) {

	const [open, setOpen] = React.useState(true);

	function _count(): number {
		return props.request.filter(x => !x.deleted).length;
	}

	let count = _count();
	if (count == 0)
		return null;

	let emp: OptionType = null;
	if (props.employee) {
		emp = {
			value: props.employee.id.toString(),
			label: props.employee.label,
			kind: "Employee",
		};
	}

	if (!open) {
		return <div>
			<IconButton size={"small"} onClick={() => setOpen(true)}><Icon>arrow_right</Icon></IconButton>
			<div style={{ display: "inline-block" }}>
				<EmployeeInfoHeader currentEmployee={emp} /> <strong>({_count()})</strong>
			</div>
		</div>
	}
	let tables: any = {};
	for (let i = 0; i < props.request.length; i++) {
		var row = props.request[i] as any;
		if (!row.resource?.kind) {
			if (!tables["_"])
				tables["_"] = [];
			tables["_"].push(row);
			continue;
		}
		if (!tables[row.resource.kind])
			tables[row.resource.kind] = [];
		tables[row.resource.kind].push(row);
	}

	return <div>
		<IconButton className="mi-icon-button" size={"small"} onClick={() => setOpen(false)}><Icon>arrow_drop_down</Icon></IconButton>
		<div style={{ display: "inline-block" }}>
			<EmployeeInfo
				currentEmployee={emp}
				editCurrentEmployee={props.editCurrentEmployee}
				employeeRelationsWindow={props.employeeRelationsWindow}
				filters={props.employeesFilters}
				onChange={(emp) => props.onChangeEmployee(props, emp)}
				employeesConfig={props.employeesConfig}
			/>
		</div>
		{Object.values(tables).map((table: IRelationRowTable[]) => {

			if (table.filter(x => !x.deleted).length == 0)
				return null;

			let kind: string = (table[0] as any)?.resource?.kind ?? "_";
			let label = "";
			if (props.getTableLabel)
				label = props.getTableLabel(kind);

			return <TableByResourceKind
				label={label}
				key={kind}
				kind={kind}
				table={table}
				copy={props.copy}
				edit={props.edit}
				onCopyClick={props.onCopyClick}
				onDeleteClick={props.onDeleteClick}
				onEditClick={props.onEditClick}
				remove={props.remove}
				classNameRow={props.classNameRow}
			>
				{props.children}
			</TableByResourceKind>;
		})}
		
	</div>
}

interface IProps {
	name: string;
	className?: string;
	value: string;
	onEditClick: (event: any, row: IRelationRowTable) => void;
	onCopyClick?: (event: any, row: IRelationRowTable) => void;
	onInitData: (rows: IAllRequest) => void;
	classNameRow?: (row: IRelationRowTable) => string;
	getTableLabel?: (kind: string) => string;
	editCurrentEmployee: boolean;
	employeesFilters: IEmployeesFilterParams,
	employeeRelationsWindow: (row: OptionType) => any;
	changeEmployee: (row: IRelationRowTable, emp: OptionType) => IRelationRowTable;
	onchangedEmployee: (rows: IRelationRowTable[], emp: OptionType) => void;
	employeesConfig?: IResourceInputConfig,

	edit: boolean,
	copy: boolean,
	remove: boolean,

	onChangedEmployees: (empl: IEmployeeEntity[]) => void,
}

interface IState {
	requestResult: IAllRequest;
	value: string;
	warningDelete: IRelationRowTable;
}

export class RequestControl extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.lastKey = 1;
		
		this.state = {
			requestResult: {},
			value: props.value,
			warningDelete: null,
		};
	}

	componentDidMount() {
		let v = this._valueToTable(this.props.value);
		this.setState({ requestResult: v });

		this.props.onInitData(v);
		this._handleChangeEmployees(v);
	}

	lastKey: number;

	private _tableToValue(request: IAllRequest): string {

		var tableResult: IRelationRowTable[] = [];
		for (var property in request) {
			if (request.hasOwnProperty(property)) {
				var table = request[property].request;
				tableResult = tableResult.concat(table);
			}
		}

		var json = JSON.stringify(tableResult);
		return json;
	}

	private _valueToTable(value: string): IAllRequest {
		if (!value) {
			return {};
		}

		var tableParsed: any[] = JSON.parse(value);
		var result: IAllRequest = {};

		this._pushRows(result, tableParsed);

		return result;
	}

	private _pushRows(result: IAllRequest, newRows: any[]): void {
		for (let i = 0; i < newRows.length; i++) {
			var row = newRows[i];
			var r = this._fillEmptyRowData(row);
			var key: string = r.employee ? r.employee.id.toString() : "_"
			if (!result[key]) {
				result[key] = {
					employee: r.employee,
					request: [],
				};
			}
			result[key].request.push(r);
		}
	}

	public searchSingle(fn: (row: IRelationRowTable) => boolean): IRelationRowTable {
		for (var property in this.state.requestResult) {
			if (this.state.requestResult.hasOwnProperty(property)) {
				var table = this.state.requestResult[property].request;
				for (let i = 0; i < table.length; i++) {
					var row = table[i];
					if (row.deleted)
						continue;

					if (fn && fn(row)) {
						return row;
					}
				}
			}
		}

		return null;
	}

	private _fillEmptyRowData(row: any): IRelationRowTable {
		if (row.key === null || row.key === undefined) {
			row.key = this.lastKey++;
		}
		
		if (row.deleted == undefined)
			row.deleted = false;

		return row;
	}

	public getRows<T extends IRelationRowTable>(): T[] {
		let results: IRelationRowTable[] = [];
		for (var property in this.state.requestResult) {
			if (this.state.requestResult.hasOwnProperty(property)) {
				var table = this.state.requestResult[property].request;
				results = results.concat(table);
			}
		}
		return results as T[];
	}

	public setRows(value: IRelationRowTable[]) {
		var result: IAllRequest = {};
		this._pushRows(result, value);

		this.setState({
			requestResult: result,
			value: this._tableToValue(result),
		});

		this._handleChangeEmployees(result);
	}

	public push(rows: any[] | any) {
		let newRows = [];
		if (Array.isArray(rows)) {
			for (let i = 0; i < rows.length; i++) {
				let row = rows[i];
				if (!this._isAdded(row)) {
					newRows.push(row);
				}
			}
		}
		else {
			if (this._isAdded(rows))
				return;
			newRows.push(rows);
		}

		this._pushRows(this.state.requestResult, newRows)

		this.setState({
			requestResult: this.state.requestResult,
			value: this._tableToValue(this.state.requestResult),
		});

		this._handleChangeEmployees(this.state.requestResult);
	}

	private _isAdded(value: IRelationRowTable): boolean {
		if (!value.relationId) {
			return false;
		}

		let existingRow = this.searchSingle(f => !f.deleted && f.relationId == value.relationId) 
		if (existingRow)
			return true;

		return false;
	}

	handleEditClick(event, row: IRelationRowTable) {
		if (this.props.onEditClick)
			this.props.onEditClick(event, row);
	}

	handleCopyClick(event, row: IRelationRowTable) {
		if (this.props.onCopyClick)
			this.props.onCopyClick(event, row);
	}

	handleDeleteClick(row: IRelationRowTable) {
		if (row.relationId) {
			this.setState({ warningDelete: row });
			return;
		}
		this._delete(row.key);
	}

	handleClose() {
		this.setState({ warningDelete: null });
	}

	handleAcceptDelete() {
		this._delete(this.state.warningDelete.key);
		this.setState({ warningDelete: null });
	}

	handleChangeEmployee(request: IRequestTable, newEmployee: OptionType) {
		let rows = this.getRows();
		for (let i = 0; i < rows.length; i++) {
			let row = rows[i];
			if (!row.deleted && request.employee?.id == row.employee?.id) {
				var parserRow = this.props.changeEmployee(row, newEmployee);
				rows[i] = { ...parserRow };
			}
		}
		this.setRows(rows);
		this.props.onchangedEmployee(rows, newEmployee);
	}

	private _delete(key: number) {

		for (var property in this.state.requestResult) {
			if (this.state.requestResult.hasOwnProperty(property)) {
				var table = this.state.requestResult[property].request;

				for (let i = 0; i < table.length; i++) {
					let row = table[i];
					if (key) {
						if (row.key == key) {
							row.deleted = true;
						}
					}
				}
			}
		}

		this.setState({
			requestResult: this.state.requestResult,
			value: this._tableToValue(this.state.requestResult),
		});

		this._handleChangeEmployees(this.state.requestResult);
	}

	private _handleChangeEmployees(requestResult: IAllRequest) {
		let requestTables = Object.values(requestResult);
		let employees = requestTables
			.filter(x => {
				if (!x.employee)
					return false;

				var any = x.request.filter(x => !x.deleted)[0];
				return !!any;
			})
			.map(x => x.employee).filter(x => !!x);

		this.props.onChangedEmployees(employees);
	}

	render() {
		let requestTables = Object.values(this.state.requestResult);

		return <div>
			<input type="hidden" name={this.props.name} value={this.state.value} />
			{requestTables.map(x => <RequestByUser
				key={x.employee?.id ?? "_empty"} {...x}

				editCurrentEmployee={this.props.editCurrentEmployee}
				employeeRelationsWindow={this.props.employeeRelationsWindow}
				employeesFilters={this.props.employeesFilters}
				employeesConfig={this.props.employeesConfig}

				copy={this.props.copy}
				edit={this.props.edit}
				remove={this.props.remove}

				onChangeEmployee={this.handleChangeEmployee.bind(this)}
				onCopyClick={this.handleCopyClick.bind(this)}
				onDeleteClick={this.handleDeleteClick.bind(this)}
				onEditClick={this.handleEditClick.bind(this)}

				classNameRow={this.props.classNameRow}
				getTableLabel={this.props.getTableLabel}
			>
				{this.props.children}
			</RequestByUser>)}
			
			<DeleteWarningDialog
				open={this.state.warningDelete != null}
				onAcceptDelete={() => this.handleAcceptDelete()}
				onClose={() => this.handleClose()}
			/>
		</div>
	}
}